import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿El precio de la calculadora es definitivo?",
    a: "No. Es una estimación orientativa. El presupuesto final se confirma tras visita técnica, medición real y revisión del estado de la obra.",
  },
  {
    q: "¿Trabajáis en toda Valencia?",
    a: "Sí, trabajamos en Valencia capital y provincia. Para zonas más alejadas valoramos un suplemento de desplazamiento.",
  },
  {
    q: "¿Puedo enviar fotos del trabajo?",
    a: "Sí. Puedes enviarnos fotos directamente por WhatsApp al 612 236 841 para que podamos valorar mejor el trabajo antes de la visita técnica.",
  },
  {
    q: "¿Hacéis trabajos pequeños?",
    a: "Sí, pero los trabajos pequeños tienen un mínimo de intervención (180 €) porque implican desplazamiento, personal, herramientas y gestión.",
  },
  {
    q: "¿El precio incluye materiales?",
    a: "Depende del servicio. Algunos precios incluyen materiales (por ejemplo, suelo laminado material incluido) y otros son sólo mano de obra. Lo aclaramos en la visita técnica.",
  },
  {
    q: "¿Hacéis reformas integrales?",
    a: "Sí. Realizamos reformas integrales, albañilería, pladur, alicatados, pavimentos, pintura, impermeabilizaciones, fontanería, electricidad y mantenimientos.",
  },
  {
    q: "¿Tenéis oficina física?",
    a: "Atendemos por WhatsApp, teléfono y visitas presenciales en obra. No disponemos de oficina física abierta al público — nuestro equipo se desplaza para valorar los trabajos directamente en la vivienda, local o comunidad.",
  },
  {
    q: "¿El IVA está incluido en la calculadora?",
    a: "No. Los precios mostrados en la calculadora no incluyen IVA. El presupuesto definitivo desglosará IVA según la normativa vigente.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-white scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Resuelve tus dudas</div>
            <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
              Preguntas frecuentes
            </h2>
            <p className="text-slate-500 mt-3 text-sm leading-relaxed">
              Si tu duda no aparece aquí, escríbenos por WhatsApp y te respondemos sin compromiso.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                  <AccordionTrigger className="text-left font-display font-medium text-slate-900 text-base hover:no-underline hover:text-[#004B87]" data-testid={`faq-q-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 text-sm leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
